import { fetchLikedArtworksLite } from "../../api-queries/GraohQlClient";

export const getLikedArtworksIds = async (): Promise<string[]> => {
  const data = await fetchLikedArtworksLite();
  return data.artworks.map((item: { _id: string }) => item._id);
};
